import { NumberFormatter, NumberFormatterProps } from '@mantine/core';

// Canonical string formatter lives in src/utils/format. Re-exported here so the
// <Currency /> component and existing importers share one implementation.
export { formatCurrency } from 'src/utils/format';

export interface ICurrencyProps
  extends Omit<
    NumberFormatterProps,
    | 'value'
    | 'prefix'
    | 'thousandSeparator'
    | 'decimalScale'
    | 'fixedDecimalScale'
    | 'placeholder'
  > {
  value: number | null | undefined;
  /** Show 2 decimal places. Defaults to 0 decimals. */
  precise?: boolean;
  /** Rendered when value is null/undefined/NaN/Infinity. 0 still formats. */
  placeholder?: React.ReactNode;
}

/** @registry Renders a number as USD via Mantine NumberFormatter ($, thousands separators, 0 or 2 decimals via `precise`); supports a placeholder for null/undefined/non-finite values. */
export const Currency: React.FC<ICurrencyProps> = ({
  value,
  precise,
  placeholder,
  ...rest
}) => {
  if (placeholder !== undefined && !Number.isFinite(value)) {
    return <>{placeholder}</>;
  }
  return (
    <NumberFormatter
      prefix="$"
      thousandSeparator
      decimalScale={precise ? 2 : 0}
      fixedDecimalScale={precise}
      value={value ?? 0}
      {...rest}
    />
  );
};
